import React, { Component, ErrorInfo, ReactNode } from 'react'

// Define the state and props interfaces for the ErrorBoundary component
interface ErrorBoundaryProps {
  children: ReactNode // Children components to be wrapped by the error boundary
}

interface ErrorBoundaryState {
  hasError: boolean // State to track if there was an error
}

// Create the ErrorBoundary class component
class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false } // Initialize state
  }

  // Lifecycle method to catch errors in child components
  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    // Update state so the next render will show the fallback UI
    return { hasError: true }
  }

  // Lifecycle method to log error information
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Log error to an error reporting service
    console.error('Error caught in ErrorBoundary:', error, errorInfo)
  }

  // Render method to display fallback UI or children
  render() {
    if (this.state.hasError) {
      // Render fallback UI when there's an error
      return <h1>Something didn't load right. Please refresh and try again.</h1>
    }

    return this.props.children // Render children if no error occurred
  }
}

export default ErrorBoundary
